//Angular Modules
import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import { FooterComponent } from "./footer/footer.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { ToggleFullscreenDirective } from "./directives/toggle-fullscreen.directive";


//Ngb components
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {ToastModule} from 'ng2-toastr/ng2-toastr';
import { NgbTooltip, NgbPopover, NgbTab, NgbTabset, NgbTabContent } from '@ng-bootstrap/ng-bootstrap';
import { FormularioLateralComponent } from './formulario-lateral/formulario-lateral.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { LightboxModule } from 'ngx-lightbox';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { ToastrComponent } from './toastr/toastr.component';
import { AndamentoTipoPipe } from 'app/pipes/andamento-tipo.pipe';
import { DataHoraHelp } from './utils/data_hora_help';
import { DespachoService } from 'app/services/despacho.service';




@NgModule({

    exports: [
        CommonModule,
        FooterComponent,
        NavbarComponent,
        SidebarComponent,
        ToggleFullscreenDirective,
        NgbTooltip,
        NgbPopover,
        FormsModule,
        ReactiveFormsModule,

        NgbTab,
        NgbTabset,
        NgbTabContent,
        FormularioLateralComponent,
        DatepickerComponent,
        LightboxModule,
        Ng2SearchPipeModule,
        ToastrComponent,
        NgbTooltip,

    ],
    imports: [

        RouterModule,
        CommonModule,
        NgbModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        ToastModule.forRoot(),
        LightboxModule,
        Ng2SearchPipeModule,

    ],
    declarations: [
        FooterComponent,
        NavbarComponent,
        SidebarComponent,
        ToggleFullscreenDirective,
        FormularioLateralComponent,
        DatepickerComponent,
        ToastrComponent,
        AndamentoTipoPipe,

        //NgbdModalContent,
        //ModalsComponent,

    ],
    bootstrap:[
        DatepickerComponent
    ]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts